export let loadingOption = {
  lock: true,
  text: "Loading...",
  spinner: "global-loading-icon",
  // 'custom-class': "global-loading-icon",
  background: "rgba(0, 0, 0, 0.6)",
};
// export let urlJWEM = "ws://69.231.186.134:36211/websocket/che";

export let url127 = "ws://127.0.0.1:8881/websocket/che";
export let url192 = "ws://192.168.1.10:8881/websocket/che";


export let urlYun = "ws://47.104.189.19:8880/websocket/che"; //云上
// export let urlYun = "ws://192.168.1.85:8880/websocket/che"; //雷哥
// export let urlYun = "ws://192.168.1.126:8880/websocket/che"; //真机
// export let urlYun = 'ws://69.231.186.134:36983/websocket/che';// 雷哥


// export let url = url127;

// export let urlJWEMHttp = "http://47.104.189.19:8879";
// export let url127Http = "http://127.0.0.1:8879";
// export let url192Http = "http://192.168.1..19:8879";
// export let urlYunHttp = "http://47.104.189.19:8879";

export let url = urlYun;
// export let httpUrl = urlYunHttp;
export function setUrl(socketUrl) {
  url = socketUrl;
}
